import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Button, Container, Grid, Stack, Typography } from '@mui/material';

import { MotionInView, varFadeInUp } from '../../animate';
import { ButtonContentProps } from '../../../@types/components-overview';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%'
}));

type PositionType = 'left' | 'right';

export interface GridContentProps {
  smallTitle?: string;
  title?: string;
  subTitle?: string;
  subTitleBold?: string;
  buttons?: Array<ButtonContentProps>;
}

const GridContent = ({
  title,
  subTitle,
  smallTitle,
  subTitleBold,
  buttons = []
}: GridContentProps) => {
  return (
    <Stack>
      <Stack spacing={2}>
        {smallTitle && (
          <Typography
            variant="overline"
            sx={{
              color: 'text.secondary'
            }}
          >
            {smallTitle}
          </Typography>
        )}
        {title && (
          <>
            <Typography
              sx={{
                display: {
                  xl: 'block',
                  lg: 'block',
                  md: 'block',
                  sm: 'none',
                  xs: 'none'
                }
              }}
              variant={'h2'}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                display: {
                  xl: 'none',
                  lg: 'none',
                  md: 'none',
                  sm: 'block',
                  xs: 'block'
                }
              }}
              variant={'h4'}
            >
              {title}
            </Typography>
          </>
        )}
        {subTitle && <Typography variant={'body1'}>{subTitle}</Typography>}
        {subTitleBold && <Typography variant={'subtitle1'}>{subTitleBold}</Typography>}
      </Stack>
      {buttons && (
        <Stack
          marginTop={'4em'}
          direction={{ sm: 'column', xs: 'column', md: 'column', lg: 'row', xl: 'row' }}
          spacing={4}
        >
          {buttons.map((button, index) => (
            <Button
              key={index}
              size={button.size}
              color={button.color}
              variant={button.variant}
              component={RouterLink}
              to={button.to}
            >
              {button.text}
            </Button>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

const Img = styled('img')(({ theme }) => ({
  width: '100%',
  borderRadius: '16px',
  zIndex: 3,
  position: 'relative'
}));

export interface LandingHugePackElementsProps {
  img?: string;
  smallTitle?: string;
  title?: string;
  subTitle?: string;
  subTitleBold?: string;
  position?: PositionType;
  buttons?: Array<ButtonContentProps>;
  decorator?: () => JSX.Element;
}

export default function LandingHugePackElements({
  img,
  subTitle,
  smallTitle,
  title,
  position = 'right',
  subTitleBold,
  buttons,
  decorator: Decorator
}: LandingHugePackElementsProps) {
  return (
    <RootStyle>
      <Container>
        <Grid
          container
          maxWidth={'lg'}
          spacing={5}
          direction={position === 'left' ? 'row-reverse' : 'row'}
        >
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <GridContent
              buttons={buttons}
              subTitleBold={subTitleBold}
              title={title}
              smallTitle={smallTitle}
              subTitle={subTitle}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <MotionInView variants={varFadeInUp}>
              {img && <Img alt={img} src={img} />}
              {Decorator && <Decorator />}
            </MotionInView>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}
